// eslint-disable-next-line no-restricted-imports
import { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { MemberResponse } from 'app/gamma/src/types/responses';

export const UPDATE_MEMBER_PREFS = Symbol('models/UPDATE_MEMBER_PREFS');
export type UpdateMemberPrefsAction = Action<
  typeof UPDATE_MEMBER_PREFS,
  MemberResponse
>;
